webpackJsonp([10],{

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-96837330",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon",
    class: [_vm.name]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 1040 1040",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('path', {
    attrs: {
      "fill": _vm.color,
      "d": _vm.icons[_vm.name]
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.componentClass,
    on: {
      "click": _vm.clickHandle
    }
  }, [(_vm.type === 'loading') ? _c('icon', {
    staticClass: "icon rotate",
    attrs: {
      "name": "i-loading",
      "color": '#fff'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'error') ? _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "i-close",
      "color": '#fff'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.content))])], 1), _vm._v(" "), (_vm.type === 'loading') ? _c('div', {
    staticClass: "mask"
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  "data-v-3d8596d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
var t = {
  'index': 'Home',
  'index_contactme': 'Contact us',
  'index_aboutus': 'About us',
  'index_platform': 'Bolo Platform',

  'index_adv': 'Advantage',
  'index_service': 'Services',
  'index_cover': 'Coverage',
  'index_partner': 'Partner',
  'index_bolo': 'Bolo Pass',

  'index_banner_title': 'Provide WeChat Acquiring and Marketing Integration Services',
  'index_appy_but': 'Apply Now',

  'index_adv_title': 'Our Superiority',
  'index_adv_text1_title': 'Convenient & secure cross-border acquiring',
  'index_adv_text1': 'After the bank liquidates, the merchant receives the Hong Kong dollar, has the money service operator license, and the fund circulation is safe and reliable',
  'index_adv_text2_title': 'Multi-Channel Online Promotion',
  'index_adv_text2': 'Cooperation with Wechat, Ali, Qyer, Mafengwo, Ctrip and so on',
  'index_adv_text3_title': 'Multi-Dimensional Interaction',
  'index_adv_text3': 'Restaurants and shoppings ⇆ attractionand entertainment',
  'index_adv_text4_title': 'Effective Support',
  'index_adv_text4': 'Staffs 24 hours Stand By to solve problems, and provide system upgrade termly',
  'index_adv_text5_title': 'Professional IT team support',
  'index_adv_text5': 'ensure payment security, the server can withstand millions of user visits, large-scale marketing events can support, rapid integration with partner systems',

  'index_service_title': 'products and services',
  'index_service_text1_name': 'WeChat Pay',
  'index_service_text1_namdes': 'Provide convenient payment methods',
  'index_service_text1_desc': 'Convenient, QR code Payment, popular by Chinese travelers.Support a variety of payment methods to meet the diverse needs.',
  'index_service_off_title': 'Offline payment support',
  'index_service_off_desc': ' Quickpay, QR code Payment, POS integration',
  'index_service_on_title': 'Online payment support',
  'index_service_on_desc': 'WeChat Public Account payment, website payment, self-service ticket machine payment',

  'index_service_text2_name': 'Bolo Merchant Platform & App',
  'index_service_text2_namdes': 'Receiving convenient, clear revenue',
  'index_service_text2_desc': 'business reports online, analyze sales trends, revenue status at a glance, super-account can instantly view a number of store sales. Support dual mode payment, payment instant notification, support multiple staff at the same time collection, real-time audit, history, sales statistics.',

  'index_service_text3_name': 'Bolo Pass',
  'index_service_text3_namdes': 'Providing a full range of marketing tools',
  'index_service_text3_desc': 'For cooperative merchants to provide online editing and platform display, the use of Bolo PASS publicity, combined with WeChat Office Account to realize the brand promotion of the merchant.',

  'index_service_text4_name': 'WeChat Office Account',
  'index_service_text4_namdes': 'Provide a new type of branding services',
  'index_service_text4_desc': 'Apply the WeChat Office Account for connecting Chinese travelers, allowing brands to deliver rich content to users through WeChat Office Account, thereby expanding the customer market.',

  'index_service_text5_name': 'Online Mall',
  'index_service_text5_namdes': 'Provide a more convenient sales platform',
  'index_service_text5_desc': 'Combined with WeChat Office Account, for each merchant to build an online store, customers can shopping online self-help, eliminating the cumbersome collection process.',

  'index_scope_title': 'Global Coverage',
  'index_scope_desc': 'Malaysia and Indonesia will be ready in the 1st quarter of 2018 Japan, Australia and New Zealand, France will be ready in the 2nd quarter of 2019',

  'index_brand_title': 'Part of Partnering Merchants',

  'index_bolo_merchant_title': 'Apply for Bolo Merchant',
  'index_input_name': 'Contact name',
  'index_input_tel': 'Phone number',
  'index_input_email': 'Contact Email',
  'index_input_city': 'City',
  'index_input_company': 'Company name',
  'index_input_company_business': 'Company business',
  'index_input_company_address': 'Company address',
  'index_input_desc': 'Your message',
  'index_no_name': 'Please enter a contact',
  'index_no_tel': 'Please enter a contact number ',
  'index_no_email': 'Please enter a concat email',
  'index_no_city': 'Please enter your city',
  'index_no_company': 'Please enter the company name',
  'index_no_company_business': 'Please enter the main business of your company',
  'index_no_company_address': 'Please enter the full address of your company',
  'index_email_error': 'Please fill in the correct email format.',
  'index_input_tip_err': 'Information is incomplete',
  'index_input_tip_succ': 'Application Success',
  'index_input_tip_timer': 'You submitted too often, please submit it {0} minutes later',
  'index_input_err_but': 'Supplementary information',
  'index_input_succ_but': 'get it',
  'index_submit': 'Submit',
  'index_input_desc_tips': '*Please understand the following rules before applying：\n' + '\n' + 'The pineapple merchants only accept applications from local merchants in Hong Kong, Thailand and Malaysia, and do not accept applications from mainland China and individual users. Services in other regions are expanding. Please fill in the company information and submit it for review in the left border. After the information is approved, local colleagues will come to you to provide services.\n' + '\n*If in doubt, please enter your message and submit.',

  'france': 'France',
  'china': 'China',
  'japan': 'Japan',
  'hk': 'HongKong',
  'tailland': 'Thailand',
  'vietnam': 'Vietnam',
  'cambodia': 'Cambodia',
  'mala': 'Malaysia',
  'newzea': 'New Zealand',
  'austra': 'Australia',

  'footer_tel_label': 'tel',
  'footer_email_label': 'email',
  'footer_adress_label': 'adress',
  'footer_adress': 'Flat 09, 13/F, Block 2, Ever Gain Plaza, No. 88 Container Port Road, Kwai Chung, N.T Hong Kong',
  'footer_bolo': 'Bolo Merchant',
  'footer_wantu': 'www.wantu.cn',
  'footer_bolo_pass': 'Bolo Pass',

  'connectme_hk_link': 'links',
  'connectme_connect_lab': 'Contact',
  'connectme_connmeth_lab': 'Contact',
  'connectme_sha': 'Shanghai Office',
  'connectme_sha_adress': ' Room B,11 Floor, Yun Du Hongqiao Mansion, 930 Zhongshan West Road, Changning District, Shanghai',
  'connectme_sz': 'Shenzhen Office',
  'connectme_sz_adress': ' Room 5A1 of BLDG 5, Nanyuanfengye Building, Nanshan Rd., Nanshan Disrtict, Shenzhen, Guangdong',
  'connectme_hk': 'Hongkong Office',
  'connectme_hk_name': 'Provider',
  'connectme_hk_adress': ' Workshop C, 22/F, Reason Group Tower, No. 403 Castle Peak Road, Kwai Chung, N.T. , Hong Kong',
  'connectme_hk_service': 'Jason Pay Limited ',
  'connectme_tail': 'Thailand Office',
  'connectme_taill_adress': ' The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand.50100',
  'connectme_vietnam': 'Vietnam Office',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': 'Kuala Lumpur Office',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': 'Sabah Office',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',

  'aboutus_wantu_title': 'FastPay Introduction',
  'aboutus_wantu_p1': 'Fast Pay Limited was established in April 2017, based in Hong Kong, branch offices are location in Shenzhen, Shanghai, and Beijing for more than 3,000 merchants, has announced a strategic partnership with WeChat pay and Alipay. The service is global coverage, business currently including Hong Kong, Thailand, Vietnam, Sabah, and Australia. Fast Pay (One Two Go Co Limited is a parent Company)  supporting WeChat pay & Alipay offline / online payment gateways and assessment for merchants. It has become a new force in the payment field in recent years. As the Chinese retail industry has been changing, characterized by the widespread use of technologies. So we provide diversified services, such as cross-border e-commerce field, to help merchants entering the new retail era.',
  'aboutus_partner': 'Partner',
  'aboutus_partner_wechat': 'WeChat Pay',
  'aboutus_partner_alipay': 'Alipay',
  'aboutus_partner_abc': 'ABC',
  'aboutus_partner_ccb': 'CCB',
  'aboutus_partner_cmb': 'CMB',
  'aboutus_partner_unpay': 'Union Pay',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': 'mafengwo',
  'aboutus_partner_qyer': 'qyer',
  'aboutus_partner_tempus': 'tempus',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': 'Activity',
  'aboutus_activity_title1': 'Alipay oversea activity of 12.12 in 2015',
  'aboutus_activity_desc1': 'To expand overseas market, third-party Payment cooperated with Hitour’s retailers in Singapore, Phuket, Chiang Mai and Pattaya.',
  'aboutus_activity_title2': 'Thailand restaurant sales promotion in 2016',
  'aboutus_activity_desc2': 'Hitour and the Thailand restaurant jointly held an unprecedented grand event - 50 percent off eating big meals',
  'aboutus_activity_title3': '2017 New Year three red envelopes',
  'aboutus_activity_desc3': 'Hitour joint Thailand Tourism Board, WeChat Pay, Ali raccoon, held in Jungceylon Shopping Destination ',
  'aboutus_award_title': 'Awards',
  'aboutus_year': '',
  'aboutus_award_p1': 'Hitour as the sole partner of Alipay activity of 12.12 in Thailand',
  'aboutus_award_p2': 'ios App recommended by App Store for 4 times',
  'aboutus_award_p3': 'Android App recommended by Wandoujia',
  'aboutus_award_p4': 'China Travel Internet Billboard Best overseas destination product booking platform',
  'aboutus_award_p5': 'Industry Innovation Award of Wechat Pay Cooperative Partner',
  'aboutus_award_p6': 'Thai Songkran WeChat Pay Overseas Media Entertainment Exclusive',
  'aboutus_award_p7': 'Bolo Pass Mini Programs was chosen as Outstanding Applet Development Representative',

  'fast_pay': {
    'index_adv': 'Advantage',
    'index_service': 'Services',
    'index_cover': 'Coverage',
    'index_partner': 'Partner',
    'index_bolo': 'Apply',

    'index_banner_title': 'EXPAND YOUR BUSINESS<br>Connect Your Business to Chinese Consumer',
    'index_appy_but': 'Apply Now',

    'index_adv_title': 'Advantage',
    'index_adv_text1_title': 'HUGE CUSTOMER FLOW',
    'index_adv_text1': 'Your store\'s info is visible to 150 million mobile Alipay customers from China',
    'index_adv_text2_title': 'INTELLIGENT MARKETING',
    'index_adv_text2': 'Precisely target customers with discount information',
    'index_adv_text3_title': 'CONVENIENT PAYMENT',
    'index_adv_text3': 'Payment products suitable for various business scenarios',
    'index_adv_text4_title': 'BUSINESS ANALYSIS',
    'index_adv_text4': 'Understand Chinese customers and provide business recommendations',

    'index_service_title': 'Services',
    'index_service_text1_name': 'In-store Payment',
    'index_service_text1_namdes': 'Including Barcode Payment and Merchant QR Code Payment',
    'index_service_text1_desc': 'It is suitable for duty-free shops, restaurants, convenience stores, shopping malls, chain stores, and other service industries.At the same time Fast Pay support for RMB and HongKong dollar trading in Alipay. The merchant only needs a Smart POS / Mobile Phone to acquiring.',
    'index_service_off_title': '線下微信⽀付',
    'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
    'index_service_on_title': '線上微信⽀付',
    'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',

    'index_service_text2_name': 'For Alipay Online Payment',
    'index_service_text2_namdes': 'Including Web / Wap / APP Payment',
    'index_service_text2_desc': 'It is suitable for PC website, mobile phone WAP and APP, and offline vending machine, POS system fusion to Alipay acquiring. It requires merchants to have the ability of technological development, and complete the connection with the API files provided by Fast Pay.',

    'index_service_text3_name': 'Bolo Merchant Platform & App',
    'index_service_text3_namdes': 'Receiving convenient, clear revenue',
    'index_service_text3_desc': 'Business reports online, analyze sales trends, revenue status at a glance, super-account can instantly view a number of store sales. Support dual mode payment, payment instant notification, support multiple staff at the same time collection, real-time audit, history, sales statistics.',
    'index_service_text3_name_2': 'Online Mall',
    'index_service_text3_namdes_2': 'Provide a more convenient sales platform',
    'index_service_text3_desc_2': 'Combined with WeChat Office Account, for each merchant to build an online store, customers can shopping online self-help, eliminating the cumbersome collection process.',

    'index_scope_title': '全球業務',
    'index_scope_desc': '⾺來⻄亞和印尼將在2018第壹季度開放。⽇本、韩国、澳⼤利亚和新⻄兰、法国將在2019戰略部署。',

    'index_brand_title': '部分合作品牌',

    'index_bolo_merchant_title': '⽴即申請支付寶收款',
    'index_input_company': '填寫公司名',
    'index_input_name': '請輸入連絡人',
    'index_input_tel': '請輸入連絡電話',
    'index_input_email': '請輸入連絡郵箱地址',
    'index_input_city': '請輸入所在都市',
    'index_input_desc': '您的留言',
    'index_no_name': '請輸入聯繫人',
    'index_no_tel': '請輸入電話號',
    'index_no_email': '請輸入郵箱',
    'index_no_city': '請輸入城市',
    'index_email_error': '請填入正確的郵箱格式',
    'index_input_tip_err': '資訊不完整',
    'index_input_tip_succ': '申請成功',
    'index_input_err_but': '繼續完善資訊',
    'index_input_succ_but': '知道了',

    'index_submit': '提交',

    'france': '法國',
    'china': '中國',
    'japan': '日本',
    'hk': '香港',
    'tailland': '泰國',
    'vietnam': '越南',
    'cambodia': '高棉',
    'mala': '馬來西亞',
    'newzea': '紐西蘭',
    'austra': '澳大利亞',

    'footer_tel_label': '電話',
    'footer_email_label': '郵箱',
    'footer_adress_label': '地址',
    'footer_adress': 'Flat 09, 13/F, Block 2, Ever Gain Plaza, No. 88 Container Port Road, Kwai Chung, N.T Hong Kong',
    'footer_bolo': '菠蘿商⼾下載',
    'footer_wantu': '玩途⾃由⾏',
    'footer_bolo_pass': '菠蘿PASS服務號',

    'connectme_hk_link': '網站',
    'connectme_connect_lab': '聯繫⼈',
    'connectme_connmeth_lab': '聯絡⽅式',
    'connectme_sha': '上海辦事處',
    'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
    'connectme_sz': '深圳辦事處',
    'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
    'connectme_hk': '⾹港辦事處',
    'connectme_hk_name': '特約服務商',
    'connectme_hk_adress': '⾹港九⻰⻓沙湾⻓裕街8号亿京⼴场1期1802室',
    'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
    'connectme_tail': '泰國辦事處',
    'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
    'connectme_vietnam': '越南辦事處',
    'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',

    'aboutus_wantu_title': 'FastPay介紹',
    'aboutus_wantu_p1': '玩途旅⾏（wantu.cn）成⽴於2013年，專註於服務中國⾃由⾏⽤⼾出境遊，提供從機票酒店預訂，⾏程中的項⽬體驗預訂，到境外商⼾移動⽀付網絡覆蓋，以及⾏程結束後的再消費。從⾃由⾏⽤⼾出境遊的⾏前、⾏中、⾏後的全⽅位服務。',
    'aboutus_wantu_p2': '2016年初，玩途旅⾏與微信⽀付簽署了境外服務商合作協議，為微信⽀付開拓海外市場，將中國的移動⽀付，無現⾦體驗推廣到世界各地，服務於廣⼤中國出境遊遊客。One TwoGo Co., Limited隸屬於玩途旅⾏，是基於⽀付服務的玩途在海外旅遊服務的⼦品牌，深⼊⽬的地當地的旅⾏指南，⼀站式搞定吃喝玩樂。在泰國、越南、⾹港、⾺來⻄亞均有當地辦事處 。',
    'aboutus_wantu_p3': '玩途旅⾏主要投資⼈是騰邦集團，2016年 騰邦集團對我們進⾏B輪融資，2017年 騰邦集團籌備與我們進⾏C輪融資。騰邦集團於深交所(300178)及港交所(6880)上市是中國500⼤企業2016年騰邦集團是全中國營收排名第80位的國企，達797億⼈⺠幣，䋿⼒強⼤。騰邦集團的旅遊佈局，亦是我們強⽽有⼒的後盾。',
    'aboutus_wantu_p4': '2017年8⽉,我們已服務超過800萬位中國遊客，其中菠蘿PASS已經擁有60萬位會員。騰邦集團每⽉為超過15萬位來港中國遊客提供針對式服務。',
    'aboutus_partner': '合作夥伴',
    'aboutus_partner_wechat': '微信⽀付',
    'aboutus_partner_alipay': '⽀付寶',
    'aboutus_partner_abc': '中國農業銀⾏',
    'aboutus_partner_ccb': '中國建設銀⾏',
    'aboutus_partner_cmb': '招商銀⾏',
    'aboutus_partner_unpay': '中國銀聯',
    'aboutus_partner_visa': 'VISA',
    'aboutus_partner_master': 'Master card',
    'aboutus_partner_mafengwo': '螞蜂窩',
    'aboutus_partner_qyer': '窮遊',
    'aboutus_partner_tempus': '騰邦',
    'aboutus_partner_jason': 'Jason Pay',
    'aboutus_activity_lab': '過往活動',
    'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
    'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
    'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
    'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
    'aboutus_activity_title3': '2017新春三重紅包好禮',
    'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
    'aboutus_award_title': '我們的獎項',
    'aboutus_year': '年',
    'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
    'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
    'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
    'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
    'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
    'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
    'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表'
  }
};

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
var t = {
  'index': '首頁',
  'index_contactme': '聯繫我們',
  'index_aboutus': '關於我們',
  'index_platform': '商戶平台',

  'index_adv': '服務優勢',
  'index_service': '產品與服務',
  'index_cover': '業務範圍',
  'index_partner': '合作品牌',
  'index_bolo': '成為菠蘿商户',

  'index_banner_title': '提供微信收款與營銷一體化服務',
  'index_appy_but': '立即申請',

  'index_adv_title': 'One Two Go的服務優勢',
  'index_adv_text1_title': '便捷安全的跨境收款',
  'index_adv_text1': '消費者微信支付人民幣，銀行清算後，商家收到港幣，具有金錢服務經營者牌照，資金流轉安全可靠',
  'index_adv_text2_title': '豐富的多渠道線上宣傳',
  'index_adv_text2': '多次與微信、⽀付寶、窮游、螞蜂窩、點評、美團、攜程合作',
  'index_adv_text3_title': '⽤⼾與商⼾間的多維互動',
  'index_adv_text3': '景點、導向、餐飲、購物、娛樂相互導流',
  'index_adv_text4_title': '⾼效的運維服務⽀援',
  'index_adv_text4': '⼯作⼈員24⼩時待命，隨時解決問題，系統定期升級',
  'index_adv_text5_title': '專業技術研發團隊⽀援',
  'index_adv_text5': '專業技術團隊，保障⽀付安全，服務器可以承受數百萬⽤⼾訪問，⼤型營銷事件可以⽀持，與合作夥伴的系統快速融合',

  'index_service_title': 'One Two Go提供的產品與服務',
  'index_service_text1_name': '微信⽀付',
  'index_service_text1_namdes': '提供便捷的⽀付⽅式',
  'index_service_text1_desc': '⽅便快捷，簡單掃碼即可⽀付，深受中國旅客喜愛。⽀持多種掃碼⽅式，滿⾜多樣化的需求。',
  'index_service_off_title': '線下微信⽀付',
  'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
  'index_service_on_title': '線上微信⽀付',
  'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',

  'index_service_text2_name': '商⼾收款平臺及APP',
  'index_service_text2_namdes': '收款便捷，營收狀況清晰',
  'index_service_text2_desc': '在線⽣成業務報表，分析銷售趨勢，營收狀況⼀⽬了然，更有超級賬號可即時查看多家⾨店銷售情況。⽀持雙重模式收款，⽀付即時收款通知，⽀持多店員同時收款，䋿時查賬、歷史查詢、銷售統計。',

  'index_service_text3_name': '菠蘿PASS',
  'index_service_text3_namdes': '提供全⽅位營銷⼿段',
  'index_service_text3_desc': '為每壹家合作商⼾提供線上編輯與平臺展示，利⽤菠蘿PASS宣傳，同時結合微信公眾號䋿現商⼾品牌推廣',

  'index_service_text4_name': '微信公眾號',
  'index_service_text4_namdes': '提供新型的品牌推廣服務',
  'index_service_text4_desc': '開通連接中國旅客的微信公眾號，品牌可透過公眾號傳遞豐富的內容給⽤⼾，從⽽擴展客⼾市場',

  'index_service_text5_name': '網上商城',
  'index_service_text5_namdes': '提供更⽅便的銷售平臺',
  'index_service_text5_desc': '與公眾號結合，為每個商⼾搭建在線商城，顧客可選購網上售賣商品⾃助下單完成購物，省去繁瑣收單流程。',

  'index_scope_title': '全球業務',
  'index_scope_desc': '印尼將在2018第二季度開放。日本、韩国、澳大利亚和新西兰、法国將在2019戰略部署。',

  'index_brand_title': '部分合作品牌',

  'index_bolo_merchant_title': '⽴即成為Bolo商⼾',
  'index_input_company': '請輸入公司名稱',
  'index_input_company_business': '請輸入公司主營業務',
  'index_input_company_address': '請輸入公司詳細地址',
  'index_input_name': '請輸入連絡人',
  'index_input_tel': '請輸入連絡電話',
  'index_input_email': '請輸入連絡郵箱地址',
  'index_input_city': '請輸入所在都市',
  'index_input_desc': '您的留言',
  'index_no_name': '請輸入聯繫人',
  'index_no_tel': '請輸入電話號',
  'index_no_email': '請輸入郵箱',
  'index_no_city': '請輸入城市',
  'index_no_company': '請輸入公司名稱',
  'index_no_company_business': '請輸入公司主營業務',
  'index_no_company_address': '請輸入公司詳細地址',
  'index_email_error': '請填入正確的郵箱格式',
  'index_input_tip_err': '資訊不完整',
  'index_input_tip_succ': '申請成功',
  'index_input_tip_timer': '您提交次數太頻繁，請{0}分鐘後提交',
  'index_input_err_but': '繼續完善資訊',
  'index_input_succ_but': '知道了',
  'index_input_desc_tips': '*申請前請了解以下細則：\n' + '\n' + '菠蘿商戶暫時只接受香港，泰國，馬來西亞當地商戶的支付申請，不接受大陸境內以及個人用戶的申請，其他地區的服務正在拓展中。請填寫公司信息在左邊框內提交審核，信息審核通過後，將會有當地同事上門為您提供服務。 \n' + '\n*如有疑問，請輸入您的留言後提交',

  'index_submit': '提交',

  'france': '法國',
  'china': '中國',
  'japan': '日本',
  'hk': '中国香港',
  'tailland': '泰國',
  'vietnam': '越南',
  'cambodia': '高棉',
  'mala': '馬來西亞',
  'newzea': '紐西蘭',
  'austra': '澳大利亞',

  'footer_tel_label': '電話',
  'footer_email_label': '郵箱',
  'footer_adress_label': '地址',
  'footer_adress': '香港新界葵涌貨櫃碼頭路88號永得利廣場2座1309室',
  'footer_bolo': '菠蘿商⼾下載',
  'footer_wantu': '玩途⾃由⾏',
  'footer_bolo_pass': '菠蘿PASS服務號',

  'connectme_hk_link': '網站',
  'connectme_connect_lab': '聯繫⼈',
  'connectme_connmeth_lab': '聯絡⽅式',
  'connectme_sha': '上海辦事處',
  'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
  'connectme_sz': '深圳辦事處',
  'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
  'connectme_hk': '⾹港辦事處',
  'connectme_hk_name': '特約服務商',
  'connectme_hk_adress': '香港新界葵涌青山道403-413號匯城集團大廈22樓C室',
  'connectme_hk_service': '戩宸有限公司 Jason Pay Limited',
  'connectme_tail': '泰國辦事處',
  'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
  'connectme_vietnam': '越南辦事處',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': '吉隆坡辦事處',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': '沙巴辦事處',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',

  'aboutus_wantu_title': 'FastPay介紹',
  'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 FastPay （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
  'aboutus_partner': '合作夥伴',
  'aboutus_partner_wechat': '微信⽀付',
  'aboutus_partner_alipay': '⽀付寶',
  'aboutus_partner_abc': '中國農業銀⾏',
  'aboutus_partner_ccb': '中國建設銀⾏',
  'aboutus_partner_cmb': '招商銀⾏',
  'aboutus_partner_unpay': '中國銀聯',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': '螞蜂窩',
  'aboutus_partner_qyer': '窮遊',
  'aboutus_partner_tempus': '騰邦',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': '過往活動',
  'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
  'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
  'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
  'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
  'aboutus_activity_title3': '2017新春三重紅包好禮',
  'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
  'aboutus_award_title': '我們的獎項',
  'aboutus_year': '年',
  'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
  'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
  'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
  'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
  'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
  'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
  'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表',

  'fast_pay': {
    'index': '首頁',
    'index_contactme': '聯繫我們',
    'index_aboutus': '關於我們',
    'index_platform': '商戶平台',

    'index_adv': '服務優勢',
    'index_service': '產品與服務',
    'index_cover': '業務範圍',
    'index_partner': '合作品牌',
    'index_bolo': '申請支付寶收款',

    'index_banner_title': 'ALIPAY支付寶商家收款方案',
    'index_appy_but': '香港商戶立即申請支付寶收款',

    'index_adv_title': '服務優勢',
    'index_adv_text1_title': '巨大的用戶群',
    'index_adv_text1': '5.2億支付寶實名用戶',
    'index_adv_text2_title': '精準營銷',
    'index_adv_text2': '精準目標客戶折扣信息',
    'index_adv_text3_title': '便捷的支付方式',
    'index_adv_text3': '適用於多種業務場景的支付產品',
    'index_adv_text4_title': '業務分析',
    'index_adv_text4': '了解中國客戶並提供商務建議',

    'index_service_title': '產品與服務',
    'index_service_text1_name': '支付寶線下收款',
    'index_service_text1_namdes': '包括掃碼支付和二維碼支付',
    'index_service_text1_desc': '適用於免稅店、餐廳、購物店、商場、連鎖店、及其他服務行業，收款的同時支援支付寶人民幣和港幣交易。商戶只需一部智能POS/手機，即可收款',
    'index_service_off_title': '線下微信⽀付',
    'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
    'index_service_on_title': '線上微信⽀付',
    'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',

    'index_service_text2_name': '支付寶線上支付',
    'index_service_text2_namdes': '包括Web / Wap /APP支付',
    'index_service_text2_desc': '適用於商戶PC網站、手機WAP / APP，以及線下自助售賣機、POS機系統融合的支付寶交易，均需要商戶具有技術開發能力，因應Fast Pay提供的API文檔完成接駁。',

    'index_service_text3_name': '商⼾收款平臺及APP',
    'index_service_text3_namdes': '收款便捷，營收狀況清晰',
    'index_service_text3_desc': '在線⽣成業務報表，分析銷售趨勢，營收狀況⼀⽬了然，更有超級賬號可即時查看多家⾨店銷售情況。⽀持雙重模式收款，⽀付即時收款通知，⽀持多店員同時收款，實時查賬、歷史查詢、銷售統計。',
    'index_service_text3_name_2': '網上商城',
    'index_service_text3_namdes_2': '提供更方便的銷售平臺',
    'index_service_text3_desc_2': '為每個商戶搭建在線商城，顧客可選購網上售賣商品自助下單完成購物，省去繁瑣收單流程。',

    'index_scope_title': '全球業務',
    'index_scope_desc': '印尼將在2018第二季度開放。日本、韩国、澳大利亚和新西兰、法国將在2019戰略部署。',

    'index_brand_title': '部分合作品牌',

    'index_bolo_merchant_title': '⽴即申請支付寶收款',
    'index_input_company': '填寫公司名',
    'index_input_name': '請輸入連絡人',
    'index_input_tel': '請輸入連絡電話',
    'index_input_email': '請輸入連絡郵箱地址',
    'index_input_city': '請輸入所在都市',
    'index_input_desc': '您的留言',
    'index_no_name': '請輸入聯繫人',
    'index_no_tel': '請輸入電話號',
    'index_no_email': '請輸入郵箱',
    'index_no_city': '請輸入城市',
    'index_email_error': '請填入正確的郵箱格式',
    'index_input_tip_err': '資訊不完整',
    'index_input_tip_succ': '申請成功',
    'index_input_err_but': '繼續完善資訊',
    'index_input_succ_but': '知道了',

    'index_submit': '提交',

    'france': '法國',
    'china': '中國',
    'japan': '日本',
    'hk': '中国香港',
    'tailland': '泰國',
    'vietnam': '越南',
    'cambodia': '高棉',
    'mala': '馬來西亞',
    'newzea': '紐西蘭',
    'austra': '澳大利亞',

    'footer_tel_label': '電話',
    'footer_email_label': '郵箱',
    'footer_adress_label': '地址',
    'footer_adress': '香港新界葵涌貨櫃碼頭路88號永得利廣場2座1309室',
    'footer_bolo': '菠蘿商⼾下載',
    'footer_wantu': '玩途⾃由⾏',
    'footer_bolo_pass': '菠蘿PASS服務號',

    'connectme_hk_link': '網站',
    'connectme_connect_lab': '聯繫⼈',
    'connectme_connmeth_lab': '聯絡⽅式',
    'connectme_sha': '上海辦事處',
    'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
    'connectme_sz': '深圳辦事處',
    'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
    'connectme_hk': '⾹港辦事處',
    'connectme_hk_name': '特約服務商',
    'connectme_hk_adress': '香港九龍長沙灣長裕街8號億京廣場1期15樓1503室',
    'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
    'connectme_tail': '泰國辦事處',
    'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
    'connectme_vietnam': '越南辦事處',
    'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
    'connectme_kuala': '吉隆坡辦事處',
    'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
    'connectme_sabah': '沙巴辦事處',
    'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',

    'aboutus_wantu_title': 'FastPay介紹',
    'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 One Two Go （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
    'aboutus_partner': '合作夥伴',
    'aboutus_partner_wechat': '微信⽀付',
    'aboutus_partner_alipay': '⽀付寶',
    'aboutus_partner_abc': '中國農業銀⾏',
    'aboutus_partner_ccb': '中國建設銀⾏',
    'aboutus_partner_cmb': '招商銀⾏',
    'aboutus_partner_unpay': '中國銀聯',
    'aboutus_partner_visa': 'VISA',
    'aboutus_partner_master': 'Master card',
    'aboutus_partner_mafengwo': '螞蜂窩',
    'aboutus_partner_qyer': '窮遊',
    'aboutus_partner_tempus': '騰邦',
    'aboutus_partner_jason': 'Jason Pay',
    'aboutus_activity_lab': '過往活動',
    'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
    'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
    'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
    'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
    'aboutus_activity_title3': '2017新春三重紅包好禮',
    'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
    'aboutus_award_title': '我們的獎項',
    'aboutus_year': '年',
    'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
    'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
    'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
    'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
    'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
    'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
    'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表'
  }
};

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
var t = {
  'index': '首页',
  'index_contactme': '联系我们',
  'index_aboutus': '关于我们',
  'index_platform': '商户平台',

  'index_adv': '服务优势',
  'index_service': '产品与服务',
  'index_cover': '业务范围',
  'index_partner': '合作品牌',
  'index_bolo': '成为菠萝商户',

  'index_banner_title': '提供微信收款与营销一体化服务',
  'index_appy_but': '立即申请',

  'index_adv_title': 'One Two Go的服务优势',
  'index_adv_text1_title': '便捷安全的跨境收款',
  'index_adv_text1': '消费者微信⽀付⼈⺠币，银⾏清算后，商家收到港币，具有⾦钱服务经营者牌照，资⾦流转安全可靠',
  'index_adv_text2_title': '丰富的多渠道线上宣传',
  'index_adv_text2': '多次与微信、⽀付宝、穷游、蚂蜂窝、点评、美团、携程合作',
  'index_adv_text3_title': '⽤户与商户间的多维互动',
  'index_adv_text3': '景点、导向、餐饮、购物、娱乐相互导流',
  'index_adv_text4_title': '⾼效的运维服务⽀援',
  'index_adv_text4': '⼯作⼈员24⼩时待命，随时解决问题，系统定期升级',
  'index_adv_text5_title': '专业技术研发团队⽀援',
  'index_adv_text5': '专业技术团队，保障⽀付安全，服务器可以承受数百万⽤户访问，⼤型营销事件可以⽀持，与合作伙伴的系统快速融合',

  'index_service_title': 'One Two Go提供的产品与服务',
  'index_service_text1_name': '微信⽀付',
  'index_service_text1_namdes': '提供便捷的⽀付⽅式',
  'index_service_text1_desc': '⽅便快捷，简单扫码即可⽀付，深受中国旅客喜爱。⽀持多种扫码⽅式，满⾜多样化的需求。',
  'index_service_off_title': '线下微信⽀付',
  'index_service_off_desc': '刷卡⽀付、扫码⽀付、POS机融合',
  'index_service_on_title': '线上微信⽀付',
  'index_service_on_desc': 'PC⽹站⽀付、⾃助售票机⽀付、⼿机⽀付、公众号⽀付',

  'index_service_text2_name': '商户收款平台及APP',
  'index_service_text2_namdes': '收款便捷，营收状况清晰',
  'index_service_text2_desc': '在线⽣成业务报表，分析销售趋势，营收状况⼀⽬了然，更有超级账号可即时查看多家⻔店销售情况。⽀持双重模式收款，⽀付即时收款通知，⽀持多店员同时收款，实时查账、历史查询、销售统计。',

  'index_service_text3_name': '菠萝PASS',
  'index_service_text3_namdes': '提供全⽅位营销⼿段',
  'index_service_text3_desc': '为每⼀家合作商户提供线上编辑与平台展示，利⽤菠萝PASS宣传，同时结合微信公众号实现商户品牌推⼴',

  'index_service_text4_name': '微信公众号',
  'index_service_text4_namdes': '提供新型的品牌推⼴服务',
  'index_service_text4_desc': '开通连接中国旅客的微信公众号，品牌可透过公众号传递丰富的内容给⽤户，从⽽扩展客户市场',

  'index_service_text5_name': '⽹上商城',
  'index_service_text5_namdes': '提供更⽅便的销售平台',
  'index_service_text5_desc': '与公众号结合，为每个商户搭建在线商城，顾客可选购⽹上售卖商品⾃助下单完成购物，省去繁琐收单流程。',

  'index_scope_title': '全球业务',
  'index_scope_desc': '⻢来⻄亚和印尼将在2018第⼀季度开放。⽇本、韩国、澳⼤利亚和新⻄兰、法国将在2019战略部署。',

  'index_brand_title': '部分合作品牌',
  'index_bolo_merchant_title': '⽴即成为Bolo商户',
  'index_input_name': '填写联系⼈姓名',
  'index_input_company': '填写公司名称',
  'index_input_company_business': '填写公司主营业务',
  'index_input_company_address': '填写公司详细地址',
  'index_input_tel': '填写联系⼈电话',
  'index_input_email': '填写联系⼈邮箱',
  'index_input_city': '填写所在城市',
  'index_input_desc': '您的留⾔',
  'index_submit': '提交',
  'index_input_desc_tips': '*申请前请了解以下细则：\n' + '\n' + '菠萝商户暂时只接受香港，泰国，马来西亚当地商户的支付申请，不接受大陆境内以及个人用户的申请，其他地区的服务正在拓展中。请填写公司信息在左边框内提交审核，信息审核通过后，将会有当地同事上门为您提供服务。\n' + '\n*如有疑问，请输入您的留言后提交',

  'index_no_name': '请输入联系人',
  'index_no_tel': '请输入电话号',
  'index_no_email': '请输入邮箱',
  'index_no_city': '请输入城市',
  'index_no_company': '请输入公司名称',
  'index_no_company_business': '请输入公司主营业务',
  'index_no_company_address': '请输入公司详细地址',
  'index_email_error': '请填入正确的邮箱格式',
  'index_input_tip_err': '信息不完整',
  'index_input_tip_succ': '申请成功',
  'index_input_tip_timer': '您提交次数太频繁，请{0}分钟后提交',
  'index_input_err_but': '继续完善信息',
  'index_input_succ_but': '知道了',

  'france': '法国',
  'china': '中国',
  'japan': '日本',
  'hk': '香港',
  'tailland': '泰国',
  'vietnam': '越南',
  'cambodia': '柬埔寨',
  'mala': '马来西亚',
  'newzea': '新西兰',
  'austra': '澳大利亚',

  'footer_tel_label': '电话',
  'footer_email_label': '邮箱',
  'footer_adress_label': '地址',
  'footer_adress': '香港新界葵涌货柜码头路88号永得利广场2座1309室',
  'footer_bolo': '菠萝商户下载',
  'footer_wantu': '玩途⾃由⾏',
  'footer_bolo_pass': '菠萝PASS服务号',

  'connectme_hk_link': '网站',
  'connectme_connect_lab': '联系⼈',
  'connectme_connmeth_lab': '联系⽅式',
  'connectme_sha': '上海办事处',
  'connectme_sha_adress': '上海市⻓宁区中⼭⻄路930号云都虹桥⼤厦11楼B座',
  'connectme_sz': '深圳办事处',
  'connectme_sz_adress': '广东省南山区南山大道南园枫叶大厦5A1',
  'connectme_hk': '⾹港办事处',
  'connectme_hk_name': '特约服务商',
  'connectme_hk_adress': '香港新界葵涌青山道403-413號匯城集團大廈22樓C室',
  'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
  'connectme_tail': '泰国办事处',
  'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
  'connectme_vietnam': '越南办事处',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': '吉隆坡办事处',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': '沙巴办事处',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',

  'aboutus_wantu_title': 'FastPay介紹',
  'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 FastPay （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
  'aboutus_partner': '合作伙伴',
  'aboutus_partner_wechat': '微信⽀付',
  'aboutus_partner_alipay': '⽀付宝',
  'aboutus_partner_abc': '中国农业银⾏',
  'aboutus_partner_ccb': '中国建设银⾏',
  'aboutus_partner_cmb': '招商银⾏',
  'aboutus_partner_unpay': '中国银联',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': '蚂蜂窝',
  'aboutus_partner_qyer': '穷游',
  'aboutus_partner_tempus': '腾邦',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': '过往活动',
  'aboutus_activity_title1': '2015年⽀付宝海外双⼗⼆狂欢节',
  'aboutus_activity_desc1': '为拓展玩途在新加坡、普吉岛、清迈、芭提雅合作的海外第三⽅⽀付市场',
  'aboutus_activity_title2': '2016年泰国餐厅5折吃⼤餐',
  'aboutus_activity_desc2': '玩途与泰国餐厅联合举办空前盛⼤活动——5折吃⼤餐',
  'aboutus_activity_title3': '2017新春三重红包好礼',
  'aboutus_activity_desc3': '玩途联⼿泰国旅游局、微信⽀付、阿狸形象，在江⻄冷举办⼤型活动',
  'aboutus_award_title': '我们的奖项',
  'aboutus_year': '年',
  'aboutus_award_p1': '⽀付宝双⼗⼆海外狂欢节，泰国唯⼀合作伙伴',
  'aboutus_award_p2': '⼿机IOS版被苹果App store四次评为“新优产品推荐”',
  'aboutus_award_p3': '⼿机的Android版获得“豌⾖荚设计奖”',
  'aboutus_award_p4': '中国旅业互联⽹风云榜最佳海外⽬的地产品预订平台',
  'aboutus_award_p5': '获得“微信⽀付合作伙伴2016年度⾏业创新奖”',
  'aboutus_award_p6': '泰国泼⽔节微信⽀付境外媒体招待玩途独家',
  'aboutus_award_p7': '菠萝通⼩程序被选为“优秀⼩程序开发代表'

};

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toast_vue__);



var vm = void 0;

var install = function install(Vue) {
  var Component = Vue.extend(__WEBPACK_IMPORTED_MODULE_1__toast_vue___default.a);

  Vue.prototype.$toast = function (content, options) {
    var autoShow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var data = {
      content: content
    };

    if (vm) {
      vm.$destroy();
    }

    if (typeof options === 'string') {
      data.type = options;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, options);
    }

    vm = new Component({ data: data }).$mount();
    if (autoShow) {
      vm.show = true;
    }

    vm.$on('destroyed', function () {
      vm = null;
    });

    return vm;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(130);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/checkout/store/qrcode',
    name: 'qrcode',
    component: function component(resolve) {
      __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/checkout/store/:store_id',
    name: 'express',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/checkout/receipt/:order_id',
    name: 'receipt',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/',
    name: 'index',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/connect_me',
    name: 'connect_me',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/about_me',
    name: 'about_me',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/fast_pay',
    name: 'fast_pay_business',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/fast_pay/connect_us',
    name: 'fast_pay_connect_us',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/fast_pay/about_us',
    name: 'fast_pay_about_us',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var icons = {
  'i-arrow-down': 'M886.226 235.396l-374.226 374.226-374.226-374.226-113.893 113.893 488.119 488.119 488.119-488.119-113.893-113.893z',
  'i-arrow-left': 'M788.603 137.774l-113.893-113.893-488.119 488.119 488.119 488.119 113.893-113.893-374.226-374.226 374.226-374.226z',
  'i-arrow-right': 'M235.396 137.774l113.893-113.893 488.119 488.119-488.119 488.119-113.893-113.893 374.226-374.226-374.226-374.226z',
  'i-arrow-up': 'M512 186.588l-488.119 488.119 113.893 113.893 374.226-374.226 374.226 374.226 113.893-113.893-488.119-488.119z',
  'i-bin': 'M134 317.667v630c0 34.65 28.35 63 63 63h567c34.65 0 63-28.35 63-63v-630h-693zM323 884.667h-63v-441h63v441zM449 884.667h-63v-441h63v441zM575 884.667h-63v-441h63v441zM701 884.667h-63v-441h63v441zM842.75 128.667h-204.75v-78.75c0-25.987-21.262-47.25-47.25-47.25h-220.5c-25.988 0-47.25 21.263-47.25 47.25v78.75h-204.75c-25.987 0-47.25 21.263-47.25 47.25v78.75h819v-78.75c0-25.987-21.263-47.25-47.25-47.25zM575 128.667h-189v-62.212h189v62.212z',
  'i-check': 'M864 88.89l-480 480-224-224-160 160 384 384 640-640z',
  'i-cog': 'M927.189 603.385c-52.887-91.599-21.073-208.964 71.031-262.324l-99.065-171.576c-27.493 16.411-60.636 26.113-96.045 26.113-0.098 0-0.196 0-0.294 0-105.853 0-191.656-86.37-191.656-192.932h-198.098c0.004 0.478 0.007 1.043 0.007 1.609 0 35.021-9.489 67.825-26.037 95.983-52.403 90.708-169.957 121.861-262.186 68.754l-99.033 171.576c38.867 22.369 68.533 57.006 84.059 98.543 39.48 63.268 7.855 180.445-83.901 233.867l99.065 171.576c27.377-16.235 60.349-25.829 95.561-25.829 0.113 0 0.226 0 0.34 0 105.504 0 191.087 85.835 191.622 191.892h198.098c0-0.159-0.001-0.347-0.001-0.535 0-35.043 9.486-67.869 26.032-96.052 52.308-90.548 169.578-121.763 261.744-69.003l99.065-171.576c-38.717-22.44-68.259-57.057-83.726-98.533zM512 710.765c-0.754 0.010-1.644 0.016-2.536 0.016-112.729 0-204.114-91.384-204.114-204.114 0-112.729 91.384-204.114 204.114-204.114 0.892 0 1.782 0.006 2.671 0.017 111.498 1.429 201.443 92.26 201.443 204.096 0 111.838-89.945 202.667-201.443 204.096z',
  'i-cross': 'M954.048 778.667l-271.968-272 271.968-272c5.034-5.085 8.144-12.083 8.144-19.808s-3.11-14.723-8.147-19.81l-128.478-128.478c-5.071-5.065-12.074-8.197-19.808-8.197s-14.737 3.132-19.808 8.197l-271.968 272-271.968-272c-5.085-5.034-12.083-8.144-19.808-8.144s-14.723 3.11-19.81 8.147l-128.478 128.478c-5.080 5.064-8.223 12.069-8.223 19.808s3.143 14.744 8.223 19.807l272.001 272.001-272 272c-5.034 5.085-8.144 12.083-8.144 19.808s3.11 14.723 8.147 19.81l128.478 128.478c5.064 5.080 12.069 8.223 19.808 8.223s14.744-3.143 19.807-8.223l271.969-272.001 271.968 272c5.085 5.034 12.083 8.144 19.808 8.144s14.723-3.11 19.81-8.147l128.478-128.478c5.080-5.064 8.223-12.069 8.223-19.808s-3.143-14.744-8.223-19.807z',
  'i-enter': 'M341.334 512h-320v-128h320v-128l192 192-192 192zM981.334 0v832l-384 192v-192h-384v-256h64v192h320v-576l256-128h-576v256h-64v-320z',
  'i-face-cool': 'M512 1010.667c278.365 0 504-225.635 504-504s-225.635-504-504-504-504 225.635-504 504 225.635 504 504 504zM512 97.167c226.17 0 409.5 183.33 409.5 409.5s-183.33 409.5-409.5 409.5-409.5-183.33-409.5-409.5 183.33-409.5 409.5-409.5zM795.5 254.667c17.325 0 31.5 14.175 31.5 31.5v94.5c0 34.65-28.35 63-63 63h-126c-34.65 0-63-28.35-63-63h-126c0 34.65-28.35 63-63 63h-126c-34.65 0-63-28.35-63-63v-94.5c0-17.325 14.175-31.5 31.5-31.5h189c17.325 0 31.5 14.175 31.5 31.5v31.5h126v-31.5c0-17.325 14.175-31.5 31.5-31.5h189zM512 758.667c0.036 0 0.080 0 0.123 0 91.267 0 171.196-48.548 215.368-121.23l54.653 31.297c-56.020 92.248-155.943 152.932-270.038 152.932-0.037 0-0.075 0-0.111 0-0.122 0-0.273 0-0.424 0-48.293 0-94.037-10.92-134.896-30.423l34.526-53.587c30.87 13.514 64.921 21.042 100.768 21.042z',
  'i-face-cry': 'M512 1010.667c278.365 0 504-225.635 504-504s-225.635-504-504-504-504 225.635-504 504 225.635 504 504 504zM512 97.167c226.17 0 409.5 183.33 409.5 409.5s-183.33 409.5-409.5 409.5-409.5-183.33-409.5-409.5 183.33-409.5 409.5-409.5z M795.5 380.667h-126c-17.397 0-31.5-14.103-31.5-31.5s14.103-31.5 31.5-31.5h126c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5zM354.5 380.667h-126c-17.397 0-31.5-14.103-31.5-31.5s14.103-31.5 31.5-31.5h126c17.397 0 31.5 14.103 31.5 31.5s-14.103 31.5-31.5 31.5zM606.5 845.292c-0.010 0-0.021 0-0.032 0-8.688 0-16.551-3.528-22.237-9.229-4.505-4.505-28.949-14.396-72.23-14.396s-67.725 9.891-72.23 14.396c-5.659 5.471-13.378 8.843-21.884 8.843-17.397 0-31.5-14.103-31.5-31.5 0-8.506 3.371-16.224 8.851-21.892 29.633-29.633 91.53-32.846 116.762-32.846s87.129 3.213 116.77 32.854c5.725 5.7 9.268 13.587 9.268 22.302 0 17.379-14.089 31.469-31.469 31.469-0.025 0-0.049 0-0.073 0zM732.5 569.667c-17.397 0-31.5-14.103-31.5-31.5v-63c0-17.397 14.103-31.5 31.5-31.5s31.5 14.103 31.5 31.5v63c0 17.397-14.103 31.5-31.5 31.5zM732.5 758.667c-17.397 0-31.5-14.103-31.5-31.5v-63c0-17.397 14.103-31.5 31.5-31.5s31.5 14.103 31.5 31.5v63c0 17.397-14.103 31.5-31.5 31.5zM291.5 569.667c-17.397 0-31.5-14.103-31.5-31.5v-63c0-17.397 14.103-31.5 31.5-31.5s31.5 14.103 31.5 31.5v63c0 17.397-14.103 31.5-31.5 31.5zM291.5 758.667c-17.397 0-31.5-14.103-31.5-31.5v-63c0-17.397 14.103-31.5 31.5-31.5s31.5 14.103 31.5 31.5v63c0 17.397-14.103 31.5-31.5 31.5z',
  'i-image': 'M931.88 146.667l0.12 0.12v719.79l-0.12 0.12-839.91-0.12v-719.79l0.12-0.12h839.79zM932 86.667h-840c-33 0-60 27-60 60v720c0 33 27 60 60 60h840c33 0 60-27 60-60v-720c0-33-27-60-60-60zM812 296.667c0 49.705-40.295 90-90 90s-90-40.295-90-90c0-49.705 40.295-90 90-90 49.705 0 90 40.295 90 90zM872 806.667h-720v-120l210-360 240 300h60l210-180z',
  'i-new-tab': 'M202.401 73.058v743.039h743.039v-743.039h-743.039zM883.519 754.176h-619.199v-619.199h619.199v619.199zM140.481 878.016v-650.159l-61.919-61.919v773.999h773.999l-61.919-61.919h-650.159zM357.2 258.817l154.8 154.8-185.759 185.759 92.88 92.88 185.759-185.759 154.8 154.8v-402.479z',
  'i-pencil': 'M858.5 2.667c86.985 0 157.5 70.515 157.5 157.5 0 35.634-11.834 68.506-31.787 94.896l-62.713 62.604-220.5-220.5 63-63c26.334-19.782 59.031-31.5 94.5-31.5zM71 727.167l-63 283.5 283.5-63 582.75-582.75-220.5-220.5-582.75 582.75zM712.403 360.57l-441 441-54.306-54.306 441-441 54.306 54.306z',
  'i-plus': 'M984.5 380.667h-346.5v-346.5c0-17.397-14.103-31.5-31.5-31.5h-189c-17.397 0-31.5 14.103-31.5 31.5v346.5h-346.5c-17.397 0-31.5 14.103-31.5 31.5v189c0 17.397 14.103 31.5 31.5 31.5h346.5v346.5c0 17.397 14.103 31.5 31.5 31.5h189c17.397 0 31.5-14.103 31.5-31.5v-346.5h346.5c17.397 0 31.5-14.103 31.5-31.5v-189c0-17.397-14.103-31.5-31.5-31.5z',
  'i-search': 'M984.752 860.443l-238.77-203.081c-24.696-22.208-51.093-32.413-72.418-31.437 56.193-65.39 90.405-151.084 90.405-244.768 0-0.184 0-0.367 0-0.551 0-208.722-169.25-377.971-378-377.971s-378 169.25-378 378 169.25 378 378 378c93.618 0 179.267-34.051 245.291-90.405-0.977 21.326 9.23 47.722 31.437 72.419l203.080 238.77c34.776 38.619 91.57 41.895 126.221 7.245s31.406-91.445-7.245-126.22zM386 632.667c-139.176 0-252-112.824-252-252s112.824-252 252-252c139.176 0 252 112.824 252 252 0 139.176-112.824 252-252 252z',
  'i-sort': 'M274.692 310.451l136.533 35.759-204.8-315.327-204.8 315.327 136.533-35.759v403.098l-136.533-35.759 208.051 315.327 204.8-315.327-136.533 35.759v-403.098zM541.257 212.927v120.279h481.117v-120.279h-481.117zM541.257 573.765h481.117v-120.279h-481.117v120.279zM541.257 814.324h481.117v-120.279h-481.117v120.279z',
  'i-star-empty': 'M1016 393.519l-348.264-50.62-155.736-315.567-155.736 315.567-348.264 50.621 252 245.637-59.503 346.846 311.503-163.769 311.503 163.769-59.503-346.846 252-245.637zM512 744.397l-219.964 115.637 42.021-244.944-177.975-173.47 245.952-35.721 109.998-222.863 109.998 222.863 245.921 35.721-177.975 173.47 42.021 244.944-219.964-115.637z',
  'i-star-full': 'M1016 393.519l-348.264-50.62-155.736-315.567-155.736 315.567-348.264 50.621 252 245.637-59.503 346.846 311.503-163.769 311.503 163.769-59.503-346.846 252-245.637z',
  'i-undo': 'M757.952 1010.667c111.951-202.829 130.819-512.19-308.952-501.858v249.858l-378-378 378-378v244.503c526.617-13.734 585.27 464.845 308.952 763.497z',
  'i-upload': 'M513.777 666.667h-480v256h960v-256h-480zM929.777 794.667h-128v-64h128v64zM257.777 282.667l256-256 256 256h-160v320h-192v-320z',
  'i-loading': 'M910.222 455.111V512H682.667v-56.889h227.555z m-625.778 0V512H56.89v-56.889h227.555z m170.667 227.556H512v227.555h-56.889V682.667z m0-625.778H512v227.555h-56.889V56.89z m341.333 699.733l-39.822 39.822-159.289-159.288 39.823-39.823 159.288 159.29zM369.778 329.956l-39.822 39.822-159.29-159.29 39.823-39.821 159.289 159.289z m-39.822 267.377l39.822 39.823-159.29 159.288-39.821-39.822 159.289-159.289z m426.666-426.666l39.822 39.822-159.288 159.289-39.823-39.822 159.29-159.29z',
  'i-close': 'M606.831242 520.060515c0.001007-2.168803-0.104715-4.337605-0.299041-6.499359l368.741734-375.125303c27.44532-27.916536 27.44532-73.131134 0-101.072842-13.711584-13.920007-31.683244-20.917768-49.661953-20.917768-17.974681 0-35.94332 6.997761-49.66598 20.917768L518.067411 401.478167 154.187862 37.503972c-14.052914-14.013646-32.449474-21.05873-50.856103-21.05873-18.403608 0-36.810237 7.045084-50.849055 21.05873-28.106835 28.124958-28.106835 73.649673 0 101.759529L433.187086 520.033329 52.481698 900.822288c-28.106835 28.106835-28.106835 73.624502 0 101.713213 28.092738 28.11791 73.609399 28.11791 101.705158 0l367.220351-367.274722 354.538797 360.676689c27.437265 27.930632 71.889661 27.930632 99.327933 0 27.44532-27.90546 27.44532-73.120059 0-101.036594L606.831242 520.060515z',
  'i-tuige': 'M642.116 507.204l69.093-69.093c10.693-10.693 8.527-22.877 8.527-22.877 0-13.13-8.258-19.763-8.258-19.763-9.07-9.07-20.17-9.204-20.17-9.204-14.486 0-23.015 9.204-23.015 9.204l-69.084 68.928-69.084-68.928c0 0-8.527-9.204-23.012-9.204 0 0-11.099 0.134-20.17 9.204 0 0-8.259 6.633-8.259 19.763 0 0-2.164 12.185 8.528 22.877l69.093 69.093-68.324 68.172c-9.477 7.714-9.477 23.011-9.477 23.011 0 11.911 9.34 21.522 9.34 21.522 8.326 8.325 20.036 7.58 20.036 7.58 15.295 0 22.336-8.391 22.336-8.391l68.991-68.993 68.993 68.993c0 0 7.041 8.391 22.336 8.391 0 0 11.709 0.746 20.035-7.58 0 0 9.341-9.612 9.341-21.522 0 0 0-15.297-9.477-23.011l-68.321-68.172L642.116 507.204zM989.365 718.388 989.365 298.061c-4.012-118.326-118.829-121.334-118.829-121.334L331.549 176.727c-15.04 0-23.733 8.524-23.733 8.524L36.484 485.078c-8.899 9.15-8.524 21.059-8.524 21.059 0 16.044 9.278 25.069 9.278 25.069l268.24 297.154c10.361 10.361 22.395 9.193 22.395 9.193l542.665 0c121.837-6.518 118.829-119.164 118.829-119.164L989.365 718.388zM953.467 730.196c0 0-1.767 62.515-62.163 62.515L330.43 792.711 73.301 506.888l259.401-285.824 558.602 0c0 0 62.163 6.36 62.163 65.696l0 443.439L953.467 730.196z'
};
/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_toast_index__ = __webpack_require__(54);










window.Promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('icon', __webpack_require__(27));

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
window.wx = __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__components_public_toast_index__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: localStorage.lang ? localStorage.lang : 'zh-tw',

  messages: {
    'zh-cn': __webpack_require__(53),
    'zh-tw': __webpack_require__(52),
    'en-us': __webpack_require__(51)
  }

});

if (location.hostname === 'www.fastpay.com.hk' && (location.pathname === '/' || location.pathname === '')) {
  location.href = '/fast_pay';
}

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_js__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    color: String
  },
  data: function data() {
    return {
      icons: __WEBPACK_IMPORTED_MODULE_0__icons_js__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icon_icon_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icon_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_icon_icon_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Toast',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_icon_icon_vue___default.a
  },
  data: function data() {
    return {
      show: false,
      content: '',
      time: 2000,
      type: 'default',
      callback: null,
      clickHide: true,
      autoDestroy: false
    };
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
    if (this.time) {
      setTimeout(this.close, this.time);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    document.body.removeChild(this.$el);
    if (this.callback) {
      this.$nextTick(function () {
        _this.callback();
      });
    }
  },
  destroyed: function destroyed() {
    this.$emit('destroyed');
  },

  computed: {
    componentClass: function componentClass() {
      return ['toast', 'toast-' + this.type];
    }
  },
  methods: {
    clickHandle: function clickHandle() {
      if (this.clickHide && this.type !== 'loading') {
        this.close();
      }
    },
    close: function close() {
      this.show = false;
    },
    afterLeave: function afterLeave() {
      if (this.autoDestroy) {
        this.$destroy();
      }
    }
  }
});

/***/ })

},[78]);


// WEBPACK FOOTER //
// static/js/app.14981c974d90c6d59a7d.js